import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteComponent } from '@app/route/route.component';
import { HeaderService } from '@app/service/header/header.service';
import { NoUserService } from '@app/service/no-user-service/no-user.service';
import { StateService } from '@app/service/state/state.service';
import { UserRegistrationDto } from '@app/service/user-service/user.service';
import { email_validation_regexp } from '../../../../assets/val/regexp';

@Component({
  selector: 'no-email-and-invoice',
  templateUrl: './no-email-and-invoice.component.html',
  styleUrls: ['../../page-shared.css', './no-email-and-invoice.component.scss'],
})
export class NoEmailAndInvoiceComponent
  extends RouteComponent
  implements OnInit
{
  showError: boolean;
  form: FormGroup;
  priorConsent: boolean = true;
  navigationInProgress = false;

  preExistingContactInfo: UserRegistrationDto;

  loading: boolean = true;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private noUserService: NoUserService,
    private formBuilder: FormBuilder
  ) {
    super(router, route, stateService, headerService);
  }

  async ngOnInit(): Promise<void> {
    try {
      let resp: boolean = await this.noUserService.getDataConsent();
      this.priorConsent = !resp;
    } catch (err) {
      this.handleError(err);
    }

    try {
      this.preExistingContactInfo =
        await this.noUserService.getActiveUserInfo();
    } catch (error) {
      this.handleError(error);
    }

    this.setupForm();
    this.loading = false;
  }

  setupForm(): void {
    this.form = this.formBuilder.group({
      email: [
        this.preExistingContactInfo?.email?.value || '',
        [Validators.pattern(email_validation_regexp), Validators.required],
      ],
      dataConsent: [this.priorConsent, [Validators.requiredTrue]],
    });
  }

  async handleCtaClick() {
    this.navigationInProgress = true;

    if (this.form.valid) {
      try {
        await this.noUserService
          .registerEmail(this.form.value.email.trim())
          .then(() => {
            this.navigate();
          });
      } catch (err) {
        this.handleError(err);
      }
    } else {
      this.showError = true;
    }

    this.navigationInProgress = false;
  }
}
